import React from 'react';

import { Icon } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import { MobileHeaderContainer } from 'components/app-header/mobile-header/styled';
import useGoBack from 'hooks/use-go-back';
import { useLocationContext } from 'state/location';
import { routes } from 'utils/routing';

import { BackArrowContainer, SignUpHeader } from './signup-mobile-header.styled';

// The types for react native do not support `dataSet` yet, but
// it is the required way to pass data-* attributes to the node.
// And we are using this mechanism to ensure these nodes are rendered
// during the pre-render, but only visible for the correct screen size.
const onlyRenderInMobile = () =>
  ({
    dataSet: { mediaquery: 'mobile' },
  } as any);

const SignupMobileHeader = () => {
  const { formatMessage } = useIntl();
  const { location, navigate } = useLocationContext();
  const goBack = useGoBack();

  const handleBack = () => {
    // Signing out leaves no safe entry behind us: the previous one is either an
    // authed page that now bounces back here, or /signout itself, which would
    // re-run sign out and push us straight back. Same when this is entry zero.
    const arrivedFromSignOut = Boolean((location.state as { isSignOut?: boolean })?.isSignOut);
    const hasPreviousEntry = Number(window.history.state?.idx ?? 0) > 0;

    if (arrivedFromSignOut || !hasPreviousEntry) {
      navigate(routes.base, { replace: true });
      return;
    }

    goBack();
  };

  return (
    <MobileHeaderContainer
      {...onlyRenderInMobile()}
      testID="signup-mobile-header"
      data-testid="signup-mobile-header"
    >
      <SignUpHeader>
        <BackArrowContainer onPress={handleBack}>
          <Icon
            icon="back"
            color="icon-default"
            width="24px"
            title={formatMessage({ id: 'back' })}
          />
        </BackArrowContainer>
      </SignUpHeader>
    </MobileHeaderContainer>
  );
};

export default SignupMobileHeader;
